import React, { useEffect, useMemo, useState } from 'react';
import { Box, ButtonBase, Checkbox, FormControlLabel, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import Text from '../../../../../../../components/Text';
import { AutoCompleteSelect } from '../../../../../../../components';
import StyleInput from '../../../../../../../components/StyleInput';
import { AddIcon, Broom, broomDouble as BroomDouble, DeleteIcon } from '../../../../../../../components/Icon';
import bs_airborne_precaution from '../../../../../../../static/images/bs_airborne_precaution.png';
import bs_droplet_precaution from '../../../../../../../static/images/bs_droplet_precaution.png';
import bs_covid from '../../../../../../../static/images/bs_covid.png';
import bs_contact_precaution from '../../../../../../../static/images/bs_contact_precaution.png';
import bs_mdro_confirmed from '../../../../../../../static/images/bs_mdro_confirmed.png';
import StyleButton from '../../../../../../../components/StyleButton';
import { bedStatusAPI, systemAPI } from '../../../../../../../apis';

const ServicesMapping = ({ enableOrderService, showOrderServiceBtn, updateWardCleansingEnable, handleSuccess }) => {
  const classes = useStyles({ enableOrderService });
  const rouList = useSelector((state) => state.rouList);
  const loginInfo = useSelector((state) => state.loginInfo);
  const [hospitalCode, setHospitalCode] = useState();
  const [aDSServiceTypeList, setADSServiceTypeList] = useState();
  const [serviceMapping, setServiceMapping] = useState({
    B: [],
    O: [],
    TD: [],
  });
  const [keyObject, setKeyObject] = useState({
    B: 0,
    O: 0,
    TD: 0,
  });

  // Ads Service Type options
  const aDSServiceTypeListOptions = useMemo(() => {
    let list = [];
    const blankOption = { text: '', value: '' };
    if (_.isArray(aDSServiceTypeList)) {
      list = _.map(aDSServiceTypeList, (item) => ({ text: item.serviceDesc, value: item.serviceCid }));
    }
    return [blankOption, ...list];
  }, [aDSServiceTypeList]);

  const initKey = (type, index) => {
    if (keyObject[type] < index) {
      setKeyObject((prevObject) => ({
        ...prevObject,
        [type]: index,
      }));
    }
    return index;
  };

  const getWardServicesMappingDetail = async () => {
    try {
      const { result } = await bedStatusAPI.getWardServicesMappingDetail();
      setServiceMapping({
        B: result?.B?.map((item, index) => ({
          ...item,
          key: initKey('B', index),
        })),
        O: result?.O?.map((item, index) => ({
          ...item,
          key: initKey('O', index),
        })),
        TD: result?.TD?.map((item, index) => ({
          ...item,
          key: initKey('TD', index),
        })),
      });
    } catch (error) {
      console.log(error);
    }
  };

  const updateWardServicesMappingDetail = async () => {
    try {
      const params = {
        serviceMapping: _.flatMap(serviceMapping).map((item) => ({
          cleaning: item.cleaning,
          cleaningCase: item.cleaningCase,
          serviceType: item.serviceType,
          serviceTypeDesc: item.serviceTypeDesc,
          serviceDesc: _.find(aDSServiceTypeListOptions, (option) => option.value === item.serviceType)?.text,
        })),
      };
      await bedStatusAPI.updateWardServicesMappingDetail(params);
      getWardServicesMappingDetail();
      handleSuccess();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardServicesMappingDetail();
  }, [rouList]);

  const getWardList = async () => {
    try {
      const { result } = await systemAPI.getSysHospitalWardList({
        hospitalId: loginInfo.hospitalId,
        wardId: null,
      });
      setHospitalCode(result?.[0]?.hospitalCode);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardList();
  }, []);

  // get Ads Service Type  api
  const getAdsServiceTypeApi = async () => {
    try {
      if (hospitalCode) {
        const { result } = await bedStatusAPI.getServiceTypeList({ hospitalCode });
        setADSServiceTypeList(result.ADSInfoDetails);
      }
    } catch (error) {}
  };

  useEffect(() => {
    getAdsServiceTypeApi();
  }, [hospitalCode]);

  const hanldeAdd = (type) => () => {
    setServiceMapping((prevServiceMapping) => ({
      ...prevServiceMapping,
      [type]: [
        ...prevServiceMapping[type],
        {
          cleaning: type,
          cleaningCase: null,
          serviceType: null,
          serviceTypeDesc: '',
          key: keyObject[type] + 1,
        },
      ],
    }));
    setKeyObject((prevObject) => ({
      ...prevObject,
      [type]: prevObject[type] + 1,
    }));
  };

  const handleDelete = (type, key) => () => {
    setServiceMapping((prevServiceMapping) => ({
      ...prevServiceMapping,
      [type]: _.filter(prevServiceMapping[type], (item) => item.key !== key),
    }));
  };

  const handleSelectServiceType = (type, key) => (value) => {
    setServiceMapping((prevServiceMapping) => ({
      ...prevServiceMapping,
      [type]: _.map(prevServiceMapping[type], (item) => ({
        ...item,
        serviceType: item.key === key ? value : item.serviceType,
      })),
    }));
  };

  const handleServiceRemark = (type, key) => (value) => {
    setServiceMapping((prevServiceMapping) => ({
      ...prevServiceMapping,
      [type]: _.map(prevServiceMapping[type], (item) => ({
        ...item,
        serviceTypeDesc: item.key === key ? value : item.serviceTypeDesc,
      })),
    }));
  };

  return (
    <Box className={classes.disabled} display="flex" flexDirection="column" flex={1} justifyContent="space-between">
      <Box>
        <Box marginBottom="1rem">
          <FormControlLabel
            id="bed_allow_popup_window"
            control={<Checkbox />}
            label="Allow “Order Service” at ward, cubicle, vacant/occupied beds’ popup window"
            className={classes.checkBox}
            checked={showOrderServiceBtn}
            onChange={(event) => updateWardCleansingEnable('showButtonYn', event?.target?.checked)}
          />
        </Box>
        <Text mb="1.87rem" color="#333333" fontSize="1.5rem" fontWeight="700">
          Services Mapping
        </Text>
        <Box display="flex">
          <Box display="flex" width="24rem">
            <Text color="#538FFF" fontSize="1rem" fontWeight="700" mb="1.19rem" textTransform="uppercase">
              Services
            </Text>
          </Box>
          <Box>
            <Text color="#538FFF" fontSize="1rem" fontWeight="700" mb="1.19rem" textTransform="uppercase">
              <span className={classes.star}>#</span> Service Type @ ads / local system
            </Text>
          </Box>
        </Box>
        {serviceMapping?.B?.map((item) => (
          <RenderItem
            title={item.key === 0 && 'Bed Cleansing'}
            Icon={item.key === 0 && Broom}
            iconSize="2.625rem"
            titleContainerMl="0.62rem"
            containerPl="0"
            value={item.serviceType}
            itemList={aDSServiceTypeListOptions}
            handleAdd={hanldeAdd('B')}
            showAdd={item.key === serviceMapping.B[serviceMapping.B.length - 1]?.key}
            showDelete={item.key !== 0}
            handleDelete={handleDelete('B', item.key)}
            onChange={handleSelectServiceType('B', item.key)}
            serviceTypeDesc={item.serviceTypeDesc}
            onRemarkChange={handleServiceRemark('B', item.key)}
            key={item.key}
          />
        ))}

        <Box display="flex" flexDirection="column" pt="1rem">
          <Box display="flex">
            <Box display="flex" width="24rem" pl="0.62rem">
              <Box display="flex" alignItems="center">
                <BroomDouble style={{ width: '2.625rem', height: '2.625rem', color: '#7F85A5' }} />
                <Text color="#2E4469" fontSize="1.125rem" ml="0.62rem">
                  Terminal Disinfection
                </Text>
              </Box>
            </Box>
          </Box>
          {serviceMapping?.TD?.map((item) => (
            <RenderItem
              title={titleEnum[item.cleaningCase]}
              Icon={RenderIcon(item.cleaningCase)}
              iconSize="2.625rem"
              titleContainerMl="0.62rem"
              value={item.serviceType}
              itemList={aDSServiceTypeListOptions}
              showAdd={item.key === serviceMapping.TD[serviceMapping.TD.length - 1]?.key}
              handleAdd={hanldeAdd('TD')}
              showDelete={!item.cleaningCase}
              handleDelete={handleDelete('TD', item.key)}
              onChange={handleSelectServiceType('TD', item.key)}
              serviceTypeDesc={item.serviceTypeDesc}
              onRemarkChange={handleServiceRemark('TD', item.key)}
              key={item.key}
            />
          ))}
        </Box>
        {serviceMapping?.O?.map((item) => (
          <RenderItem
            title={item.key === 0 && 'Other Non-Cleansing Service'}
            titleContainerMl="0.62rem"
            containerPl="0"
            value={item.serviceType}
            itemList={aDSServiceTypeListOptions}
            handleAdd={hanldeAdd('O')}
            showAdd={item.key === serviceMapping.O[serviceMapping.O.length - 1]?.key}
            showDelete={item.key !== 0}
            handleDelete={handleDelete('O', item.key)}
            onChange={handleSelectServiceType('O', item.key)}
            serviceTypeDesc={item.serviceTypeDesc}
            onRemarkChange={handleServiceRemark('O', item.key)}
            key={item.key}
          />
        ))}
      </Box>
      <Box display="flex" flexDirection="column" p="1rem 2rem 2rem">
        <Text color="#ff0300">
          #
          <br />
          <br />
          If the cleansing service is by manually order, just select blank.
          <br />
          <br />
          The cleansing service mapping only affect the default selection at discharge order. User can still select
          other service type.
          <br />
          <br />
          Click &quot;+Add&quot; if you want to add more service.
          <br />
          <br />
          As not all ADS/local service types support calling by Ward Place, kindly test all services selected in this
          page at Ward Place and ADS/local system before go live.
          <br />
          <br />
          Current Ward Place does NOT support mapping service with following criteria:
          <br />
          • &quot;Starting point&quot; is not equal to &quot;Destinatoin&quot; location (e.g. 運送病人 ) or
          <br />• (for ADS) Patient qty / info is required (e.g. 抽血 )
        </Text>
        <Box display="flex" alignItems="center" justifyContent="center" flex={1} mt="1rem">
          <StyleButton text="Save" type="fill" onClick={updateWardServicesMappingDetail} />
        </Box>
      </Box>
    </Box>
  );
};

const RenderItem = ({
  title,
  titleMl = '0.62rem',
  titleContainerMl,
  containerPl = '3.87rem',
  Icon,
  iconSize,
  handleAdd,
  value,
  onChange,
  itemList = [],
  showAdd,
  showDelete,
  handleDelete,
  serviceTypeDesc,
  onRemarkChange,
}) => {
  const classes = useStyles();
  return (
    <Box display="flex">
      <Box display="flex" width="24rem" pl={containerPl} borderBottom="1px solid #E4E7EB">
        <Box display="flex" alignItems="center" p="1rem 0" height="5.5rem" width="100%" ml={titleContainerMl}>
          {Icon && <Icon style={{ width: iconSize, height: iconSize, color: '#7F85A5' }} />}
          <Text color="#2E4469" fontSize="1.125rem" ml={titleMl}>
            {title}
          </Text>
        </Box>
      </Box>
      <Box
        display="flex"
        flexDirection="column"
        gridGap="1.428rem"
        borderBottom="1px solid #E4E7EB"
        p="1rem 0"
        flex={1}
      >
        <Box display="flex">
          <AutoCompleteSelect
            width="20rem"
            value={value}
            itemList={itemList}
            onChange={onChange}
            placeholder="Select Type"
          />
          <StyleInput
            className={classes.remarkInput}
            width="20rem"
            value={serviceTypeDesc || ''}
            onChange={onRemarkChange}
            placeholder="Service type description"
          />
          {showDelete && (
            <Box display="flex" alignItems="center" justifyContent="center" ml="1.5rem">
              <StyleButton
                width="2.25rem"
                height="2.25rem"
                borderRadius="0.5rem"
                Icon={DeleteIcon}
                onClick={handleDelete}
              />
            </Box>
          )}
        </Box>
        {showAdd && (
          <ButtonBase className={classes.addBtn} onClick={handleAdd}>
            <AddIcon />
            Add
          </ButtonBase>
        )}
      </Box>
    </Box>
  );
};

const RenderIcon = (cleaningCase) => () => {
  const iconEnum = [
    {
      cleaningCase: 'AIRBORNE_PRECAUTION',
      icon: bs_airborne_precaution,
      iconWidth: '1.0625rem',
      iconHeight: '0.72rem',
    },
    {
      cleaningCase: 'DROPLET_PRECAUTION',
      icon: bs_droplet_precaution,
      iconWidth: '1.0625rem',
      iconHeight: '0.72rem',
    },
    {
      cleaningCase: 'COVID19',
      icon: bs_covid,
      iconWidth: '1.25rem',
      iconHeight: '1.25rem',
    },
    {
      cleaningCase: 'CONTACT_PRECAUTION',
      icon: bs_contact_precaution,
      iconWidth: '1.0625rem',
      iconHeight: '0.72rem',
    },
    {
      cleaningCase: 'MDRO',
      icon: bs_mdro_confirmed,
      iconWidth: '1.75rem',
      iconHeight: '1.25rem',
    },
  ];
  const iconItem = _.find(iconEnum, (item) => item.cleaningCase === cleaningCase);
  return iconItem ? (
    <Box
      width="2.75rem"
      height="2.75rem"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="50%"
      border="1px solid #DDD"
    >
      <img src={iconItem.icon} alt="" style={{ width: iconItem.iconWidth, height: iconItem.iconHeight }} />
    </Box>
  ) : (
    <div />
  );
};

const titleEnum = {
  AIRBORNE_PRECAUTION: 'Airborne Prcaution',
  DROPLET_PRECAUTION: 'Droplet Precaution',
  CONTACT_PRECAUTION: 'Contact Precaution',
  MDRO: 'MDRO',
  COVID19: 'Covid-19',
};

const useStyles = makeStyles(() => ({
  addBtn: {
    color: '#538FFF',
    fontSize: '1.125rem',
    fontWeight: '700',
    gap: '0.25rem',
    alignSelf: 'flex-start',
  },
  remarkInput: {
    marginLeft: '0.714rem',
  },
  disabled: ({ enableOrderService }) =>
    enableOrderService
      ? {}
      : {
          pointerEvents: 'none',
          opacity: 0.5,
        },
  star: {
    color: '#ff0300',
  },
  checkBox: {
    '& .MuiCheckbox-root': {
      color: '#c0c6cb',
    },
    '& .MuiTypography-root': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
    '& .Mui-checked': {
      color: '#28d2ab',
    },
  },
}));

export default ServicesMapping;
